
function setScope(scopeName,resolve, reject, ...args) {
    window.sentry.configureScope(scope => {
        // set the user
        let funName = 'set' + scopeName
        if(funName in scope){
            scope[funName](...args)
            resolve()
        }  
      })
}
function setData(scopeName, ...args){
    return new Promise((resolve,reject) => {
        if(process.env.BROWSER){
            if(window.sentry){
                setScope(scopeName,resolve, reject, ...args)
            } else {
                // 多次监听
                document.addEventListener('__errorTrackerLoaded__', () => {
                    setScope(scopeName, resolve, reject, ...args)
                })
            }
        }
    })
}


export default {
    setUser(userData){
        return setData('User',userData)
    },
    setTag(tagName,tagVaule){
        return setData('Tag', tagName, tagVaule)
    },
    
}